import styled from 'styled-components'
import { Card } from 'rendition'

export const IntroCard = styled(Card)`
  background: transparent;
  color: white;
  border: none;
  box-shadow: none;
  min-width: 300px;
  max-width: 700px;
`

export default IntroCard